<template>
  <div class="BankProggres">
    <div class="flex" v-if="!goodTitle.length">
      <h4>Хорошо</h4>
      <Proggres :value="good" />
    </div>
    <v-tooltip left v-if="goodTitle.length">
      <template v-slot:activator="{ on, attrs }">
        <div class="flex" v-bind="attrs" v-on="on">
          <h4>Хорошо</h4>
          <Proggres :value="goodTitle.length" />
        </div>
      </template>
      <span v-html="goodTitle.join('<br/>')" />
    </v-tooltip>

    <div class="flex" v-if="!badTitle.length">
      <h4>Плохо</h4>
      <Proggres :value="badTitle.length" :good="false" />
    </div>

    <v-tooltip left v-if="badTitle.length">
      <template v-slot:activator="{ on, attrs }">
        <div class="flex" v-bind="attrs" v-on="on">
          <h4>Плохо</h4>
          <Proggres :value="badTitle.length" :good="false" />
        </div>
      </template>
      <span v-html="badTitle.join('<br/>')" />
    </v-tooltip>

    <div class="flex">
      <span><strong>Звонят клиентам напрямую</strong> - сообщили в
      <span v-if="item.recommend === 1">{{item.recommend}} отзыве</span>
      <span v-if="item.recommend !== 1">{{item.recommend}} отзывах</span>
      </span>
    </div>
  </div>
</template>
<script>
import Proggres from "./proggres.vue";
export default {
  name: "BankProggres",
  components: { Proggres },
  data: () => ({
    goodTitle: [],
    badTitle: [],
    good: 0,
    bab: 0,
  }),
  props: {
    item: { type: Object, default: () => ({}) },
  },
  methods: {
    init() {

      this.goodTitle = []
      this.badTitle = []
      for (const [key, value] of Object.entries(this.item.items)) {
        if (value > 0) {
          // this.goodTitle.push(`${key}: ${value}`);
          this.goodTitle.push(`${key}`);
        }
        if (value < 0) {
          // this.badTitle.push(`${key}: ${value * -1}`);
          this.badTitle.push(`${key}`);
        }
      }
    },
  },
  created() {
    this.init();
  },
  watch:{
    item(){
      this.init();
    }
  }
};
</script>
<style lang="sass" scoped>
.flex
  align-items: center
</style>
